/*
 * Excel host strategy.
 * Delegates to the co-located ExcelHost class which contains the full
 * AI assistant implementation (chat UI, agent service, action handlers).
 */

import type { IHostStrategy } from "../host-strategy";

export class ExcelHostStrategy implements IHostStrategy {
  readonly hostType = "Excel";

  async init(): Promise<void> {
    const { ExcelHost } = await import("./excel");
    await new ExcelHost().init();
  }
}
